import React, { useEffect } from 'react';
import { useToast } from '../../context/ToastContext';
import { returnAxiosError } from '../../utils/returnAxiosError';
import api from '../../services/api';
import { useState, useCallback } from 'react';

import {
  Container,
  ContainerInputs,
  InputNome,
  SalvarButton,
  Pesquisa,
  CardCategoria,
  GroupBox,
  GroupBoxLegenda,
  ToggleCircle,
  ToggleContainer,
  ToggleText,
  CheckBoxContainer,
} from './styles';

import ICategoria from '../../routes/vms/ICategoria';

import ColorPicker from '../../components/colorPicker';

import { FiTrash2, FiDollarSign } from 'react-icons/fi';
import Dialog from '../../components/dialog';
import Monetizacao from '../Monetizacao';
import { useAuth } from '../../context/AuthContext';

const Categoria: React.FC = () => {
  const [categorias, setCategorias] = useState<ICategoria[]>([]);
  const [nome, setNome] = useState('');
  const [cor, setCor] = useState('');
  const [selecionada, setSelecionada] = useState<ICategoria | null>(null);
  const [inutilizar, setInutilizar] = useState(false);
  const [monetizada, setMonetizada] = useState(false);
  const [metade, setMetade] = useState(false);
  const [monetizacaoOpen, setMonetizacaoOpen] = useState(false);
  const { verifyAccess } = useAuth();

  const { addToast } = useToast();

  const updateLista = useCallback(() => {
    api
      .get<ICategoria[]>('/categoria/lista', { params: { inutilizar } })
      .then(response => {
        setCategorias(response.data);
      });
  }, [inutilizar]);

  useEffect(() => {
    updateLista();
  }, [updateLista]);

  const limpaCategoria = useCallback(() => {
    setNome('');
    setCor('');
    setSelecionada(null);
    setMonetizada(false);
    setMetade(false);
  }, []);

  const handleSalvarCategoria = useCallback(async () => {
    try {
      if (selecionada) {
        await api.put('/categoria/' + selecionada.id, {
          nome,
          cor,
          inutilizar,
          monetizada,
          metade_intervalo: metade,
        });
      } else {
        await api.post('/categoria', {
          nome,
          cor,
          inutilizar,
          monetizada,
          metade_intervalo: metade,
        });
      }
    } catch (error) {
      addToast(returnAxiosError(error));

      return;
    }

    limpaCategoria();

    addToast({
      type: 'success',
      title: 'Categoria salva!',
    });

    updateLista();
  }, [
    cor,
    addToast,
    nome,
    updateLista,
    selecionada,
    limpaCategoria,
    inutilizar,
    monetizada,
    metade,
  ]);

  const handleExcluirCategoria = useCallback(
    async (id: string) => {
      try {
        await api.delete('/categoria/' + id);
      } catch (error) {
        addToast(returnAxiosError(error));

        return;
      }

      addToast({
        type: 'success',
        title: 'Categoria excluída!',
      });

      limpaCategoria();
      updateLista();
    },
    [addToast, updateLista, limpaCategoria],
  );

  const handleCorChange = useCallback((cor: string) => {
    setCor(cor);
  }, []);

  return (
    <Container>
      <GroupBox>
        <GroupBoxLegenda>Categoria</GroupBoxLegenda>

        <ContainerInputs>
          <span>
            <InputNome
              variant="outlined"
              margin="normal"
              id="nome"
              label="Categoria"
              name="nomeCategoria"
              type="text"
              value={nome}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setNome(e.target.value)
              }
            />

            <ToggleContainer
              onClick={() => {
                setInutilizar(!inutilizar);
              }}
            >
              <ToggleCircle inutilizado={inutilizar} />
              <ToggleText inutilizado={inutilizar}>
                {inutilizar ? 'Bloq.' : 'Normal'}
              </ToggleText>
            </ToggleContainer>
          </span>

          <ColorPicker onChange={handleCorChange} cor={cor} />

          <SalvarButton onClick={handleSalvarCategoria}>Salvar</SalvarButton>
        </ContainerInputs>

        <CheckBoxContainer>
          <label>
            <input
              type="checkbox"
              checked={monetizada}
              onChange={() => {
                setMonetizada(!monetizada);
              }}
            />
            Monetizar
          </label>

          <label>
            <input
              type="checkbox"
              checked={metade}
              onChange={() => {
                setMetade(!metade);
              }}
            />
            Metade do intervalo
          </label>
        </CheckBoxContainer>

        <Pesquisa>
          {categorias.map(categoria => (
            <CardCategoria
              key={categoria.id}
              cor={categoria.cor}
              onClick={() => {
                setNome(categoria.nome);
                setCor(categoria.cor);
                setMonetizada(categoria.monetizada);
                setMetade(categoria.metade_intervalo);
                setSelecionada(categoria);
              }}
            >
              <p>{categoria.nome}</p>

              <div>
                {categoria.monetizada &&
                verifyAccess('VISUALIZAR CADASTRO DE PREÇOS DAS CATEGORIAS') ? (
                  <FiDollarSign
                    onClick={() => {
                      setMonetizacaoOpen(true);
                      setSelecionada(categoria);
                    }}
                  />
                ) : (
                  ''
                )}
                <FiTrash2
                  onClick={() => {
                    handleExcluirCategoria(categoria.id);
                  }}
                />
              </div>
            </CardCategoria>
          ))}
        </Pesquisa>
      </GroupBox>

      <Dialog
        isOpen={monetizacaoOpen}
        onClose={() => {
          setMonetizacaoOpen(false);
          limpaCategoria();
          updateLista();
        }}
      >
        <Monetizacao categoria_param={selecionada} />
      </Dialog>
    </Container>
  );
};

export default Categoria;
